import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Close as CloseIcon } from '@vicons/ionicons5';
import { ref, onBeforeMount, computed } from 'vue';
import { NImage, NPopover, NInputGroup, FormInst, NButton, NCard, NInput, NForm, NFormItemGi, NAutoComplete, NAvatar, NTag, NUpload, NIcon, NGrid, NSpace } from 'naive-ui';
import $msg from '@/utils/message';
import getBase from '@/utils/base';
import { Email } from '@vicons/carbon';
import WxBindComp from '@/components/system/WxBindComp.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfoModal',
  props: ['submitId', 'disabled'],
  emits: ['close', 'submit'],
  setup(__props, { expose, emit: emits }) {

const props = __props;

const { $api, $store, t, changeParam, reInitAuth } = getBase();
const user = computed(() => $store.state.auth.user);


let param = ref<any>({
	id: null,
	name: null,
	account: null,
	email: null,
	openId: null
});

let avatarUploadFinishFun = function (options: { file: any, event?: ProgressEvent }) {
	reInitAuth();
}

let avatarFileList = computed<any>(() => {
	if (user.value.avatarId) {
		return [{
			id: 'avatarId',
			name: 'avatar.png',
			status: 'finished',
			url: $api.commonUrl.filePreview('' + user.value.avatarId)
		}];
	}
	return [];
});

const emailOptions = computed(() => {
	return ['@gmail.com', '@163.com', '@qq.com'].map((suffix) => {
		if (!param.value.email) {
			param.value.email = '';
		}
		const prefix = param.value.email.split('@')[0]
		return {
			label: prefix + suffix,
			value: prefix + suffix
		}
	})
});
let submitId = ref(props.submitId);
let disabled = ref(props.disabled);
onBeforeMount(() => {
	changeParam(param.value, user.value);
})
const form = ref<FormInst | null>(null);
const rules = <any>{
	rule: {
		required: true,
		message: t("validate.not_empty"),
		trigger: ['input', 'blur']
	},
	ruleNumber: {
		type: "number",
		required: true,
		message: t("validate.not_empty"),
		trigger: ['input', 'blur']
	},
	ruleSelect: {
		type: "number",
		required: true,
		message: t("validate.not_empty"),
		trigger: ['blur', 'change']
	},
	ruleEnumSelect: {
		required: true,
		message: t("validate.not_empty"),
		trigger: ['blur', 'change']
	}
};

function cancel() {
	emits('close');
}
function submit(e: MouseEvent) {
	e.preventDefault();
	form.value?.validate((errors) => {
		if (!errors) {
			emits('submit', param.value);
		} else {
			$msg.error(t("validate.invalid"));
		}
	})
}
function closeFun() {
	emits('close');
}

expose({
	submitId,
	param
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NCard), {
    style: {"width":"500px"},
    bordered: false,
    size: "huge",
    role: "dialog",
    "aria-modal": "true"
  }, {
    "header-extra": _withCtx(() => [
      _createVNode(_unref(NButton), {
        size: "tiny",
        secondary: "",
        onClick: cancel
      }, {
        icon: _withCtx(() => [
          _createVNode(_unref(NIcon), null, {
            default: _withCtx(() => [
              _createVNode(_unref(CloseIcon))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(NSpace), { justify: "end" }, {
        default: _withCtx(() => [
          (_unref(disabled))
            ? (_openBlock(), _createBlock(_unref(NButton), {
                key: 0,
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('close')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_unref(disabled))
            ? (_openBlock(), _createBlock(_unref(NButton), {
                key: 1,
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('cancel')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_unref(disabled))
            ? (_openBlock(), _createBlock(_unref(NButton), {
                key: 2,
                type: "success",
                onClick: submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('submit')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(NForm), {
        ref_key: "form",
        ref: form,
        model: _unref(param),
        rules: _unref(rules),
        disabled: _unref(disabled)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NGrid), { cols: 24 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NFormItemGi), {
                span: 24,
                label: _unref(t)('system.user.avatar')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), { align: "flex-end" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NAvatar), {
                        style: {"border-color":"gray"},
                        bordered: true,
                        size: "small",
                        src: _unref($api).commonUrl.filePreview('' + _unref(user).avatarId),
                        "fallback-src": require(`@/assets/img/default_avatar.png`)
                      }, null, 8, ["src", "fallback-src"]),
                      _createVNode(_unref(NAvatar), {
                        style: {"border-color":"gray"},
                        bordered: true,
                        size: "medium",
                        src: _unref($api).commonUrl.filePreview('' + _unref(user).avatarId),
                        "fallback-src": require(`@/assets/img/default_avatar.png`)
                      }, null, 8, ["src", "fallback-src"]),
                      _createVNode(_unref(NAvatar), {
                        style: {"border-color":"gray"},
                        bordered: true,
                        size: "large",
                        src: _unref($api).commonUrl.filePreview('' + _unref(user).avatarId),
                        "fallback-src": require(`@/assets/img/default_avatar.png`)
                      }, null, 8, ["src", "fallback-src"]),
                      _createVNode(_unref(NAvatar), {
                        style: {"border-color":"gray"},
                        bordered: true,
                        size: 48,
                        src: _unref($api).commonUrl.filePreview('' + _unref(user).avatarId),
                        "fallback-src": require(`@/assets/img/default_avatar.png`)
                      }, null, 8, ["src", "fallback-src"]),
                      _createVNode(_unref(NAvatar), {
                        style: {"border-color":"gray"},
                        bordered: true,
                        size: 70,
                        src: _unref($api).commonUrl.filePreview('' + _unref(user).avatarId),
                        "fallback-src": require(`@/assets/img/default_avatar.png`)
                      }, null, 8, ["src", "fallback-src"]),
                      (!_unref(disabled))
                        ? (_openBlock(), _createBlock(_unref(NUpload), {
                            key: 0,
                            action: _unref($api).commonUrl.userSetAvatar(),
                            "default-file-list": _unref(avatarFileList),
                            "list-type": "image-card",
                            accept: "image/png, image/jpeg",
                            max: 1,
                            onFinish: _unref(avatarUploadFinishFun)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('upload')), 1)
                            ]),
                            _: 1
                          }, 8, ["action", "default-file-list", "onFinish"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NFormItemGi), {
                "rule-path": "rule",
                path: "name",
                span: 24,
                label: _unref(t)('system.user.name')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: _unref(param).name,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(param).name) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NFormItemGi), {
                "rule-path": "rule",
                path: "account",
                span: 24,
                label: _unref(t)('system.user.account')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: _unref(param).account,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(param).account) = $event))
                  }, null, 8, ["value"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NFormItemGi), {
                "rule-path": "rule",
                path: "email",
                span: 24,
                label: _unref(t)('system.user.email')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NAutoComplete), {
                    value: _unref(param).email,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(param).email) = $event)),
                    options: _unref(emailOptions),
                    placeholder: _unref(t)('system.user.email'),
                    size: "large"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_unref(NIcon), { component: _unref(Email) }, null, 8, ["component"])
                    ]),
                    _: 1
                  }, 8, ["value", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NFormItemGi), {
                path: "openId",
                span: 24,
                label: _unref(t)('system.user.openId')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInput), {
                        value: _unref(param).openId,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(param).openId) = $event)),
                        placeholder: "",
                        disabled: true
                      }, null, 8, ["value"]),
                      (!_unref(disabled))
                        ? (_openBlock(), _createBlock(_unref(NPopover), {
                            key: 0,
                            trigger: "click"
                          }, {
                            trigger: _withCtx(() => [
                              _createVNode(_unref(NButton), {
                                type: "primary",
                                ghost: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('bind')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(WxBindComp, { onClose: closeFun })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NFormItemGi), {
                span: 24,
                label: _unref(t)('system.user.role')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(user).roles, (role, index) => {
                        return (_openBlock(), _createBlock(_unref(NTag), {
                          type: "success",
                          key: role
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(role.name), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules", "disabled"])
    ]),
    _: 1
  }))
}
}

})